import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;

// Section counts so entry points only appear once a section has real listings.
export function useDirectoryAvailability() {
  const [counts, setCounts] = useState(null);
  useEffect(() => {
    cache = cache || api.get("/directory/sections").then((r) => Object.fromEntries(r.data.map((s) => [s.slug, s.count]))).catch(() => ({}));
    let live = true;
    cache.then((c) => live && setCounts(c));
    return () => { live = false; };
  }, []);
  return counts;
}
